// extracted by mini-css-extract-plugin
module.exports = {"root":"ImagesTable_root__34PWz","row":"ImagesTable_row__4RZIy","cell":"ImagesTable_cell__38O7Z"};